import { AnalysisRequirementItem } from 'modules/analyse/types/AnaylsisRequirementItem';
import { AnalysisRequirementInput } from 'modules/analyse/types/AnalysisRequirementInput';
import { AnalysisRequirementUpdateInput } from 'services/candidate/types';

export const formatAnalysisRequirementsForSubmission = (
  analysisRequirements: AnalysisRequirementInput[],
  initialAnalysisRequirements: AnalysisRequirementItem[]
): {
  requirementsToCreate: AnalysisRequirementInput[];
  requirementsToUpdate: AnalysisRequirementUpdateInput[];
  requirementsToDelete: string[];
} => {
  const requirementsToCreate = analysisRequirements
    .filter((req) => !req.id)
    .map((req) => ({
      content: req.content,
      isMandatory: req.isMandatory,
      weight: req.weight,
      isRecommendationDismissed: req.isRecommendationDismissed,
      recommendationCategory: req.recommendationCategory,
      recommendationText: req.recommendationText
    }));

  const requirementsToUpdate = analysisRequirements.reduce(
    (updates: AnalysisRequirementUpdateInput[], req) => {
      if (!req.id) return updates;

      const initialReq = initialAnalysisRequirements.find(
        (initialReq) => initialReq.id === req.id
      );

      if (
        initialReq &&
        (initialReq.isMandatory !== req.isMandatory ||
          initialReq.weight !== req.weight ||
          initialReq.originalRequirementText !== req.content ||
          initialReq.isRecommendationDismissed !==
            req.isRecommendationDismissed ||
          initialReq.recommendationCategory !== req.recommendationCategory ||
          initialReq.recommendationText !== req.recommendationText)
      ) {
        const updatedContent =
          req.content === initialReq.originalRequirementText
            ? undefined
            : req.content;

        updates.push({
          id: req.id as string,
          isMandatory: req.isMandatory,
          weight: req.weight,
          updatedContent,
          isRecommendationDismissed: req.isRecommendationDismissed,
          recommendationCategory: req.recommendationCategory,
          recommendationText: req.recommendationText
        });
      }

      return updates;
    },
    []
  );

  const requirementsToDelete = initialAnalysisRequirements
    .filter((req) => !analysisRequirements.find((r) => r.id === req.id))
    .map((req) => req.id);

  return {
    requirementsToCreate,
    requirementsToUpdate,
    requirementsToDelete
  };
};
